import React, { Component } from 'react';
import { connect } from 'react-redux';
import LinearProgress from 'material-ui/LinearProgress';
import classnames from 'classnames';

class KiotLoader extends Component {

    constructor(props) {
        super(props);

    }

    render() {
        var { show_loader } = this.props;

        var ProgressClass = classnames({
            'fade-bg': true,
            'opacity-1': show_loader,
            'opacity-0': !show_loader
        })

        return (
            <div>
                <div className={ProgressClass}>
                    <LinearProgress mode="indeterminate" className="z-9999 h-6px" />
                </div>
            </div>
        )
    }
}




const mapStateToProps = (state) => ({
    show_loader: state.settings.show_loader
});

export default connect(mapStateToProps)(KiotLoader)


// WEBPACK FOOTER //
// ./components/ui/Loader.js